import { Directive, ElementRef, HostListener, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputList]'
})
export class AppInputListDirective {

  @Input() isList ? = 'false';
  @Input() withSpace ? = 'false';
  @Input() withSpecialCharacters ? = 'false';
  regExp = (/[a-zA-Z0-9\u00f1\u00d1]/);
  regExpWithSpecialCharacters = (/[a-zA-Z0-9\u00f1\u00d1\_\-]/);
  regExpSpace = (/[a-zA-Z0-9\u00f1\u00d1\_\-\s]/);
  regExpWithSpecialCharactersAndSpace = (/[a-zA-Z0-9\u00f1\u00d1\_\-\s]/);
  regExpList = (/[a-zA-Z0-9,\u00f1\u00d1]/);
  regExpListWithSpecialCharacters = (/[a-zA-Z0-9,\u00f1\u00d1\_\-]/);
  regExpListSpace = (/[a-zA-Z0-9,\u00f1\u00d1\s]/);
  regExpListSpaceAndWithSpecialCharacters = (/[a-zA-Z0-9,\u00f1\u00d1\_\-\s]/);
  constructor(@Self() private ngControl: NgControl, private element: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(evento: KeyboardEvent): boolean {
    const tecla = evento.key;
    const valor: string = this.element.nativeElement.value;
    if (this.isList === 'true') {
      if (this.withSpace === 'true' && this.withSpecialCharacters === 'true') {
        if (!this.regExpListSpaceAndWithSpecialCharacters.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      } else if (this.withSpace === 'false' && this.withSpecialCharacters === 'true') {
          if (!this.regExpListWithSpecialCharacters.test(tecla)) {
            this.ngControl.control.setValue(valor);
            return false;
          }
      } else if (this.withSpace === 'true' && this.withSpecialCharacters === 'false') {
          if (!this.regExpListSpace.test(tecla)) {
            this.ngControl.control.setValue(valor);
            return false;
          }
      } else {
        if (!this.regExpList.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      }
    } else {
      if (this.withSpace === 'true' && this.withSpecialCharacters === 'true') {
        if (!this.regExpWithSpecialCharactersAndSpace.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      } else if (this.withSpace === 'true' && this.withSpecialCharacters === 'false') {
        if (!this.regExpSpace.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      } else if (this.withSpace === 'false' && this.withSpecialCharacters === 'true') {
        if (!this.regExpWithSpecialCharacters.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      } else {
        if (!this.regExp.test(tecla)) {
          this.ngControl.control.setValue(valor);
          return false;
        }
      }
    }
  }
}
